(() => {
  const init = () => {
    const announcement = document.querySelector('[data-ip-rebrand-announcement]');
    if (announcement) {
      const key = 'innovapharm_packaging_notice_v1';
      try { announcement.hidden = sessionStorage.getItem(key) === 'dismissed'; } catch {}
      announcement.querySelector('[data-ip-rebrand-dismiss]')?.addEventListener('click', () => {
        announcement.hidden = true;
        try { sessionStorage.setItem(key, 'dismissed'); } catch {}
      });
    }
    document.querySelectorAll('[data-ip-previous-packaging]').forEach(block => {
      const root = block.closest('#ip-refined');
      const input = root?.querySelector('form [data-ip-variant]');
      const stage = block.querySelector('[data-ip-previous-stage]');
      if (!input || !stage) return;
      let current = '';
      const sync = () => {
        const template = [...block.querySelectorAll('template[data-ip-previous-id]')].find(item => item.dataset.ipPreviousId === input.value);
        block.hidden = !template;
        if (!template) { stage.replaceChildren(); block.open = false; current = ''; return; }
        if (current !== input.value) { stage.replaceChildren(template.content.cloneNode(true)); current = input.value; }
      };
      sync();
      root.addEventListener('change', () => queueMicrotask(sync));
      root.addEventListener('click', () => queueMicrotask(sync));
      new MutationObserver(sync).observe(input, { attributes: true, attributeFilter: ['value'] });
    });
    if (location.hash === '#ip-packaging-faq') {
      const faq = document.getElementById('ip-packaging-faq');
      if (faq) faq.open = true;
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
